import { Box } from '@skin-seoul/design-system';
import { HiddenGemSection } from './HiddenGemSection/HiddenGemSection';
import { AmazonSection } from './AmazonSection/AmazonSection';
import { BeforeAfterSlider } from '../components/BeforeAfterSlider';
export const GGUSection = () => {
  return <Box width="100%" background="#ffffff" boxSizing="border-box" maxWidth={{
    base: '100%',
    tablet: '1280px'
  }} margin={{
    base: 0,
    tablet: '0 auto'
  }} data-sentry-element="Box" data-sentry-component="GGUSection" data-sentry-source-file="GGUSection.tsx">
      <Box width="100%" height="100%" display={{
      base: 'none',
      desktop: 'block'
    }} data-sentry-element="Box" data-sentry-source-file="GGUSection.tsx">
        <BeforeAfterSlider content={{
        rightSection: <HiddenGemSection />,
        leftSection: <AmazonSection />
      }} data-sentry-element="BeforeAfterSlider" data-sentry-source-file="GGUSection.tsx" />
      </Box>
      <Box width="100%" height="100%" display={{
      base: 'block',
      desktop: 'none'
    }} data-sentry-element="Box" data-sentry-source-file="GGUSection.tsx">
        <AmazonSection data-sentry-element="AmazonSection" data-sentry-source-file="GGUSection.tsx" />
        <HiddenGemSection data-sentry-element="HiddenGemSection" data-sentry-source-file="GGUSection.tsx" />
      </Box>
    </Box>;
};